<script>
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'file-type-name-limit-list',
    props: {
        additionalListItems: Array,
        allowedFileTypes: {
            type: Array,
            default: () => Laravel.allowedFileTypes
        }
    },
    computed: {
        filenameRegex() {
            return Laravel.filenameRegex
        },
        regexSet() {
            return this.filenameRegex != null
        },
        allowedFileTypesSorted() {
            //let allowedMediaTypes = []
            let allowedExtensions = []

            this.allowedFileTypes.forEach(fileType => {
                if(fileType.includes('/')) {
                    //allowedMediaTypes.push(fileType)
                } else {
                    allowedExtensions.push(fileType)
                }
            })

            //allowedMediaTypes.sort()
            allowedExtensions.sort()

            return allowedExtensions //allowedMediaTypes.concat(allowedExtensions)
        },
        forbiddenSymbols() {
            return ['*', '\"', '/', ':', '<', '>', '?', '\\', '|']
        },
        t_filename_limitation() {
            if (this.regexSet) {
                return Lang.langGet("File names must match this regex: :regex", {regex: ''});
            } else {
                return Lang.langGet("File names must not contain the following symbols: ' * \" / : < > ? \\ | '").slice(0, -21)
            }
        },
        t_filetype_limitation() {
            return Lang.langGet("Allowed file types/extensions are: :limitation.", {limitation: ''}).slice(0, -1)
        },
    }
})
</script>

<template>
    <ul>
        <li>{{ t_filename_limitation }}
            <div class="filename-limitation-container">
                <v-chip v-for="forbiddenSymbol in regexSet ? [filenameRegex] : forbiddenSymbols"
                        :key="forbiddenSymbol"
                        :color="'white'"
                        label
                        small
                        text-color="black">{{ forbiddenSymbol }}
                </v-chip>
            </div>
        </li>
        <li>{{ t_filetype_limitation }}
            <div class="filename-limitation-container"> <!--filetype-limitation-container-->
                <v-chip v-for="allowedFileType in allowedFileTypesSorted"
                        :key="allowedFileType"
                        :color="'white'"
                        label
                        small
                        text-color="black">{{ allowedFileType }}
                </v-chip>
            </div>
        </li>
        <li v-for="additionalItem in additionalListItems" :key="additionalItem">{{ additionalItem }}</li>
    </ul>
</template>
